export default {
  menuIsActive: false,
}
